exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Banner{position:relative}.Banner span{width:100%;height:100%;position:absolute;top:0;left:0;z-index:10;background:rgba(0,0,0,.5)}.Banner .item{position:relative;height:240px;background-size:cover;opacity:.5}.Banner .box{width:90%;height:40px;position:absolute;left:50%;top:50%;margin-left:-45%;margin-top:-20px;text-align:center;z-index:11}.Banner .box .title-banner{font-size:45px;color:#fff}@media (max-width:640px){.Banner .item{height:240px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1241f164","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Banner.vue
// module id = 97
// module chunks = 0